import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { chatAPI } from 'services/api';
import { RootState } from 'store/rootReducer';

export declare interface TagInterface {
  id?: string;
  cor?: string;
  nome?: string;
}

export declare interface TagInterfaceV2 {
  id?: string;
  color?: string;
  name?: string;
}

type TagsState = {
  tags: TagInterface[];
  loadingTags: boolean;
};

export const fetchTags = createAsyncThunk('tags/fetchTags', async () => {
  const response = await chatAPI.get('tags');
  return response.data.data as TagInterface[];
});

const initialState: TagsState = {
  tags: [],
  loadingTags: false,
};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchTags.pending, state => {
      state.loadingTags = true;
    });
    builder.addCase(fetchTags.fulfilled, (state, action) => {
      state.loadingTags = false;
      state.tags = action.payload;
    });
    builder.addCase(fetchTags.rejected, state => {
      state.loadingTags = false;
    });
  },
});

// selectors

export const tagsSelector = (state: RootState) => state.tags;

export default tagsSlice.reducer;
